// a function that removes all \n and \t and html tags from a string
const removeHtmlTagsAndWhitespace = string => {

	string = string.replace(/<[^>]*>?/gm, "").replace(/\n/gm, "").replace(/\t/gm, "");
	string = string.trim();

	return string;
};

/**
 * add_shipping_info event
 */

// trigger when a WooCommerce shipping method radio is changed
// Scope to the canonical shipping_method[<package>] radios so payment-method
// inputs (e.g. payment aggregators such as Autopay/BlueMedia that render many
// sub-channel radios) can never match and flood GA4 with bogus
// add_shipping_info events carrying payment names in shipping_tier.
jQuery("form.woocommerce-checkout").on("change", "input[name^='shipping_method']", (event) => {

	if (!event.target?.value) return;
	if (!event.target?.id) return;

	triggerAddShippingInfoEvent({
		slug: event.target.value,
		text: removeHtmlTagsAndWhitespace(jQuery("label[for='" + event.target.id + "']").text()),
	});
});

// trigger when a shipping method is already selected on page load
jQuery(() => {

	// select the checked shipping-method radio by its canonical name, not by a
	// container id, so we never pick up payment-method or other inputs
	let checkedShippingMethod = jQuery("form.woocommerce-checkout input[name^='shipping_method']:checked").first();

	if (!checkedShippingMethod.length) return;
	if (!checkedShippingMethod.val()) return;
	if (!checkedShippingMethod.attr("id")) return;

	triggerAddShippingInfoEvent({
		slug: checkedShippingMethod.val(),
		text: removeHtmlTagsAndWhitespace(jQuery("label[for='" + checkedShippingMethod.attr("id") + "']").text()),
	});
});

// dedupe consecutive add_shipping_info triggers for the same shipping tier, so
// WooCommerce update_checkout re-renders can't re-emit the same event repeatedly
let lastShippingTierSlug = null;

// trigger the add_shipping_info event for a shipping tier
const triggerAddShippingInfoEvent = shippingTier => {

	if (shippingTier.slug === lastShippingTierSlug) return;
	lastShippingTierSlug = shippingTier.slug;

	jQuery(document).trigger("pmw:add-shipping-info", {shippingTier});
};

/**
 * add_payment_info event
 */

	  // flag to prevent double logging of payment method change on pageload
let paymentMethodChangeLogged = false;

// trigger when a payment method is selected
jQuery("form.woocommerce-checkout").on("change", "input[name=\"payment_method\"]", event => {

	if (!event.target.value) return;
	if (!event.target.id) return;

	triggerAddPaymentInfoEvent({
		slug: event.target.value,
		text: removeHtmlTagsAndWhitespace(jQuery("label[for='" + event.target.id + "']").text()),
	});

	paymentMethodChangeLogged = true;
});

// trigger when a payment method is already selected on page load
jQuery(() => {

	// prevent double logging of payment method change on pageload
	if (paymentMethodChangeLogged) return;

	let checkedPaymentMethod = jQuery("input[name=\"payment_method\"]:checked");

	if (checkedPaymentMethod.length) {

		if (!checkedPaymentMethod.val()) return;
		if (!checkedPaymentMethod.attr("id")) return;

		triggerAddPaymentInfoEvent({
			slug: checkedPaymentMethod.val(),
			text: removeHtmlTagsAndWhitespace(jQuery("label[for='" + checkedPaymentMethod.attr("id") + "']").text()),
		});
	}
});

// trigger when a payment method is selected on page load
const triggerAddPaymentInfoEvent = paymentType => {
	jQuery(document).trigger("pmw:add-payment-info", {paymentType});
};

/**
 * remove_from_cart event
 *
 * Cannot be attached directly because the mini cart doesn't necessarily contain the remove button on page load.
 */
jQuery(document).on("click", ".remove_from_cart_button, .remove", (event) => {

	// console.log("remove_from_cart event" + new Date().getTime())

	try {

		let url       = new URL(jQuery(event.currentTarget).attr("href"));
		let productId = pmw.getProductIdByCartItemKeyUrl(url);

		pmw.removeProductFromCart(productId);

	} catch (e) {
		console.error(e);
	}
});


/**
 * begin_checkout event
 *
 * Cannot be attached directly because the mini cart doesn't necessarily contain the remove button on page load.
 */
let checkoutButtonClasses = [
	// ".checkout", // this is too generic. It triggers on the checkout page on some themes fore each interaction with the checkout form.
	".checkout-button",
	".cart-checkout-button",
	".button.checkout",
	".xoo-wsc-ft-btn-checkout", // https://xootix.com/side-cart-for-woocommerce/
	".elementor-button--checkout",
	".xt_woofc-checkout", // https://wordpress.org/plugins/woo-floating-cart-lite/
	".fkcart-checkout--text", // https://funnelkit.com/
];

const checkoutButtonSelectors = pmw.prepareSelectors(checkoutButtonClasses, "beginCheckout");

// https://wordpress.stackexchange.com/a/352171/68337
jQuery(document).on("click init_checkout", checkoutButtonSelectors, () => {
	jQuery(document).trigger("pmw:begin-checkout");
});

jQuery(document).on("updated_cart_totals", () => {
	jQuery(document).trigger("pmw:view-cart");
});

/**
 * Set up PWM events
 */

// track checkout option event: purchase click
// https://wordpress.stackexchange.com/a/352171/68337
jQuery(document).on("pmwLoad", (event) => {
	jQuery(document).on("payment_method_selected", () => {

		if (false === pmw.paymentMethodSelected) {
			pmw.fireCheckoutProgress(3);
		}

		pmw.fireCheckoutOption(3, jQuery("input[name='payment_method']:checked").val());
		pmw.paymentMethodSelected = true;
	});
});

// populate the pmwDataLayer with the cart items
jQuery(document).on("pmwLoad", () => {

	try {
		pmw.initCart();
	} catch (e) {
		console.error(e);
	}
});

/**
 * Keep the stored cart hash in sync with client-tracked cart changes.
 *
 * WooCommerce passes the fresh cart hash with these events after every AJAX
 * cart mutation. Recording it prevents initCart from treating our own tracked
 * changes as a server-side desync and re-fetching the cart on the next page.
 * Cart changes without these events (non-AJAX form adds, server-side changes)
 * are reconciled by initCart through a one-time backend fetch instead.
 */
jQuery(document.body).on("added_to_cart removed_from_cart", (event, fragments, cartHash) => {

	try {
		if (cartHash) pmw.storeData("cart_hash", cartHash);
	} catch (e) {
		console.error(e);
	}
});

// get all add-to-cart= products from backend
jQuery(document).on("pmwLoad", () => {

	pmwDataLayer.products = pmwDataLayer.products || {};

	// scan page for add-to-cart= links
	let productIds = pmw.getAddToCartLinkProductIds();

	pmw.getProductsFromBackend(productIds);
});

/**
 * Save the referrer into a cookie
 *
 * @returns {void}
 */
jQuery(document).on("pmwLoad", () => {

	// If there is no referrer, then return
	if (!document.referrer) {
		return;
	}

	// If the referrer is already stored, then return
	if (pmw.retrieveData("referrer")) {
		return;
	}

	let referrerUrl      = new URL(document.referrer);
	let referrerHostname = referrerUrl.hostname;

	if (referrerHostname !== window.location.host) {
		pmw.storeData("referrer", referrerHostname);
	}
});

/**
 * Collect parameters from the URL
 * and save them to the PMW session storage.
 * Parameters:
 * - gclid
 * - wbraid
 * - gbraid
 * - fbclid
 * - ttclid
 * - ScCid
 * - epik
 *
 * @returns {void}
 * */
jQuery(document).on("pmwLoad", () => {

	let gclid = pmw.getUrlParameter("gclid");
	if (gclid) pmw.storeData("gclid", gclid);

	let wbraid = pmw.getUrlParameter("wbraid");
	if (wbraid) pmw.storeData("wbraid", wbraid);

	let gbraid = pmw.getUrlParameter("gbraid");
	if (gbraid) pmw.storeData("gbraid", gbraid);

	// https://developers.facebook.com/docs/marketing-api/conversions-api/parameters/fbp-and-fbc
	let fbclid = pmw.getUrlParameter("fbclid");
	if (fbclid) {
		// fbc format: fb.<subdomainIndex>.<creationTimeMs>.<fbclid>
		// The creation time must be in milliseconds (13 digits). Meta's fbevents.js
		// writes it that way, and PMW's isValidFbc / is_valid_fbc validators enforce
		// exactly 13 digits (\d{13}), so a seconds-based timestamp would be dropped.
		fbclid = "fb.1." + Date.now() + "." + fbclid;
		pmw.storeData("fbclid", fbclid);
	}

	let ttclid = pmw.getUrlParameter("ttclid");
	if (ttclid) pmw.storeData("ttclid", ttclid);

	let scid = pmw.getUrlParameter("ScCid");
	if (scid) pmw.storeData("scid", scid);

	let epik = pmw.getUrlParameter("epik");
	if (epik) pmw.storeData("epik", epik);
});

/**
 * Create our own load event in order to better handle script flow execution when JS "optimizers" shuffle the code.
 */
jQuery(document).on("pmwLoad", () => {
	// document.addEventListener("pmwLoad", function () {
	try {
		if (typeof pmwDataLayer != "undefined" && !pmwDataLayer?.pmw_loaded) {

			jQuery(document).trigger("pmw:load-always");

			if (pmwDataLayer?.shop) {
				if (
					"product" === pmwDataLayer.shop.page_type &&
					"variable" !== pmwDataLayer.shop.product_type &&
					pmw.getMainProductIdFromProductPage()
				) {
					let product = pmw.getProductDataForViewItemEvent(pmw.getMainProductIdFromProductPage());
					jQuery(document).trigger("pmw:view-item", product);
				} else if (
					"product" === pmwDataLayer.shop.page_type &&
					"variable" === pmwDataLayer.shop.product_type &&
					!pmwDataLayer?.shop?.variations_output &&
					pmw.getMainProductIdFromProductPage()
				) {
					// For variable products with variations_output disabled, fire view_item with parent product data
					let product = pmw.getProductDataForViewItemEvent(pmw.getMainProductIdFromProductPage());
					jQuery(document).trigger("pmw:view-item", product);
				} else if ("product_category" === pmwDataLayer.shop.page_type) {
					jQuery(document).trigger("pmw:view-category");
				} else if ("search" === pmwDataLayer.shop.page_type) {
					jQuery(document).trigger("pmw:search");
				} else if ("cart" === pmwDataLayer.shop.page_type) {
					jQuery(document).trigger("pmw:view-cart");
				} else if ("order_received_page" === pmwDataLayer.shop.page_type) {
					if (pmwDataLayer?.order && !pmw.isOrderIdStored(pmwDataLayer.order.id)) {
						jQuery(document).trigger("pmw:purchase");
						pmw.writeOrderIdToStorage(pmwDataLayer.order.id, pmwDataLayer.order.key);
						if (typeof pmw.acrRemoveCookie === "function") pmw.acrRemoveCookie();
					}
				} else {
					jQuery(document).trigger("pmw:everywhere-else");
				}
			} else {
				jQuery(document).trigger("pmw:everywhere-else");
			}

			if (pmwDataLayer?.user?.id && !pmw.hasLoginEventFired()) {
				jQuery(document).trigger("pmw:login");
				pmw.setLoginEventFired();
			}

			if (pmwDataLayer?.user?.account_just_created && !pmw.hasAccountCreatedEventFired()) {
				jQuery(document).trigger("pmw:account-created");
				pmw.setAccountCreatedEventFired();
			}

			pmwDataLayer.pmw_loaded = true;
		}

	} catch (e) {
		console.error(e);
	}
});

/**
 * Register the show_variation event listener
 * in case lazy loading is enabled
 * because we have to register it immediately
 * and not after the onready event.
 */
if (pmwDataLayer?.general?.lazy_load_pmw) {
	pmw.registerShowVariationEventListener();
}

/**
 * In case lazy loading is enabled
 * we need to trigger the view-item event on
 * preselected variations.
 *
 * Check if a variation is selected on a variable product page
 * and trigger the view-item event if a variation is selected
 *
 * Fallback for the jQuery(".single_variation_wrap").on("show_variation", (event, variation) => {}) event listener
 * in case lazy loading is enabled and the event listener is not triggered.
 *
 * Only fires if variations_output is enabled, as the parent product view_item
 * is already triggered on page load when variations_output is disabled.
 */
jQuery(document).on("pmwLoad", () => {
	if (!pmwDataLayer?.general?.lazy_load_pmw) return;
	if (!pmwDataLayer?.shop?.variations_output) return;

	try {
		const $variationForm = jQuery(".variations_form");
		if (!$variationForm.length) return;

		const selectedValues = {};
		const allSelected    = $variationForm.find("select").toArray().every(select => {
			const value = jQuery(select).val();
			if (value) {
				selectedValues[jQuery(select).attr("name")] = value;
				return true;
			}
			return false;
		});

		if (!allSelected) return;

		const productVariations = $variationForm.data("product_variations");
		if (!productVariations) return;

		const matchingVariation = productVariations.find(variation =>
			Object.entries(selectedValues).every(([key, value]) =>
				variation.attributes[key] === value,
			),
		);

		if (matchingVariation) {
			pmw.triggerViewItemEventPrep(matchingVariation.variation_id);
		}
	} catch (e) {
		pmw.console.error(e);
	}
});

// Check if the REST endpoint is available and log an error if it is not
jQuery(document).on("pmwLoad", async () => {
	if (pmw.getRestStatus() === false) pmw.console.error("REST endpoint is not available. Using admin-ajax.php instead.");
});

/**
 * All s2s events
 */

/**
 * PageView event
 *
 * Uses the unified event processing system with filters.
 * Each pixel's adapter handles the data transformation.
 * S2S transmission is controlled by the supportsPageViewS2S capability.
 */
jQuery(document).on("pmw:page-view", async (event) => {

	pmw.console.log("pmw:page-view event fired", {event});

	// Use the unified event processor
	const payload = await pmw.processEvent("page_view", {});

	// Only send to server if pageview S2S is enabled AND there are pixels with this capability
	if (pmwDataLayer?.general?.server_2_server?.pageview_event_s2s?.is_active) {
		const pageViewS2SPixels = pmw.pixelRegistry.getPixelsWithCapability("supportsPageViewS2S");

		if (pageViewS2SPixels.length > 0) {

			// Run the server-side enrichment phase (e.g. wait for Facebook's _fbp cookie)
			// before building the S2S payload. The browser pixel has already fired above.
			await pmw.enrichServerPixels(payload, pageViewS2SPixels);

			// Extract S2S data only for pixels that support pageview S2S
			const s2sData = {event: "page_view"};

			for (const pixelName of pageViewS2SPixels) {
				if (payload.pixels[pixelName]) {
					s2sData[pixelName] = payload.pixels[pixelName];
				}
			}

			if (Object.keys(s2sData).length > 1) { // More than just 'event' key
				pmw.sendEventPayloadToServer(s2sData);
			}
		}
	}
});

/**
 * Add to cart event
 *
 * Uses the new unified event processing system with filters
 */
jQuery(document).on("pmw:add-to-cart", async (event, product) => {

	pmw.console.log("pmw:add-to-cart event fired", {event, product});

	// Use the new unified event processor
	await pmw.processEvent("add_to_cart", {
		product: product,
	});
});

/**
 * Remove from cart event
 * Uses the new unified event processing system with filters
 */
jQuery(document).on("pmw:remove-from-cart", async (event, product) => {

	pmw.console.log("pmw:remove-from-cart event fired", {event, product});

	// Use the new unified event processor
	await pmw.processEvent("remove_from_cart", {
		product: product,
	});
});

/**
 * Select item event
 * Uses the new unified event processing system with filters
 */
jQuery(document).on("pmw:select-item", async (event, product) => {

	pmw.console.log("pmw:select-item event fired", {event, product});

	// Use the new unified event processor
	await pmw.processEvent("select_item", {
		product: product,
	});
});

/**
 * View cart event
 */
jQuery(document).on("pmw:view-cart", (event) => {

	pmw.console.log("pmw:view-cart event fired", {event});

	/**
	 * Process the event through the unified event processor
	 */
	pmw.processEvent("view_cart", {});
});

/**
 * Begin checkout event
 */
jQuery(document).on("pmw:begin-checkout", (event) => {

	pmw.console.log("pmw:begin-checkout event fired", {event});

	// Remember that a begin_checkout fired for the current cart, so the
	// checkout-page-load trigger below doesn't duplicate it. The flag is
	// reset in pmw.initCart when the WooCommerce cart ceases to exist.
	// Never let a storage failure block the event itself.
	try {
		pmw.storeData("begin_checkout_fired", true);
	} catch (e) {
		pmw.console.error(e);
	}

	/**
	 * Process the event through the unified event processor
	 */
	pmw.processEvent("begin_checkout", {});
});

/**
 * Begin checkout on checkout page load
 *
 * Shoppers can reach the checkout page without clicking a "proceed to
 * checkout" button: funnel builders (e.g. CartFlows next-step buttons that
 * add the product server-side while the checkout page renders), buy-now
 * buttons, direct checkout links, or block-based carts whose checkout links
 * don't match the click selectors above. In those flows the click trigger
 * never runs, so fire begin_checkout when the checkout page loads instead.
 *
 * Deduplicated against every other begin_checkout path through the session
 * flag stamped in the pmw:begin-checkout listener above: a shopper who did
 * click a checkout button doesn't produce a second event when the checkout
 * page then loads. Fires only when the WooCommerce cart has items.
 *
 * Can be disabled with the pmw_fire_begin_checkout_on_checkout_page filter.
 */
jQuery(document).on("pmwLoad", () => {

	try {
		if ("checkout" !== pmwDataLayer?.shop?.page_type) return;
		if (true !== pmwDataLayer?.shop?.begin_checkout_on_checkout_page) return;
		if (pmw.hasBeginCheckoutFired()) return;
		if (!pmw.doesWooCommerceCartExist()) return;

		pmw.triggerBeginCheckoutWhenCartReady();

	} catch (e) {
		console.error(e);
	}
});

/**
 * Add Shipping Info
 */
jQuery(document).on("pmw:add-shipping-info", (event, data = {}) => {

	pmw.console.log("pmw:add-shipping-info event fired", {event, data});

	/**
	 * Process the event through the unified event processor
	 */
	pmw.processEvent("add_shipping_info", data);
});

/**
 * Add Payment Info
 */
jQuery(document).on("pmw:add-payment-info", (event) => {

	pmw.console.log("pmw:add-payment-info event fired", {event});

	/**
	 * Process the event through the unified event processor
	 */
	pmw.processEvent("add_payment_info", {});
});

/**
 * Add to wishlist event
 *
 * Uses the unified event processing system with filters.
 * Each pixel's adapter handles the data transformation.
 */
jQuery(document).on("pmw:add-to-wishlist", async (event, product) => {

	pmw.console.log("pmw:add-to-wishlist event fired", {event, product});

	// Use the unified event processor
	await pmw.processEvent("add_to_wishlist", {
		product: product,
	});
});

/**
 * View Item List event
 */
jQuery(document).on("pmw:view-item-list", (event, product = null) => {

	pmw.console.log("pmw:view-item-list event fired", {event, product});

	/**
	 * Process the event through the unified event processor
	 */
	pmw.processEvent("view_item_list", {
		product: product,
	});
});

/**
 * View Item event
 */
jQuery(document).on("pmw:view-item", (event, product = null) => {

	pmw.console.log("pmw:view-item event fired", {event, product});

	/**
	 * Process the event through the unified event processor
	 */
	pmw.processEvent("view_item", {
		product: product,
	});
});

/**
 * View category event
 *
 * Uses the unified event processing system with filters.
 * Each pixel's adapter handles the data transformation.
 */
jQuery(document).on("pmw:view-category", async (event, product = null) => {

	pmw.console.log("pmw:view-category event fired", {event, product});

	// Use the unified event processor
	await pmw.processEvent("view_category", {
		product: product,
	});
});

/**
 * Search event
 */
jQuery(document).on("pmw:search", (event) => {

	pmw.console.log("pmw:search event fired", {event});

	/**
	 * Process the event through the unified event processor
	 */
	pmw.processEvent("search", {});
});

/**
 * Place order event
 *
 * Uses the unified event processing system with filters.
 * Each pixel's adapter handles the data transformation.
 */
jQuery(document).on("pmw:place-order", async (event) => {

	pmw.console.log("pmw:place-order event fired", {event});

	// Use the unified event processor
	await pmw.processEvent("place_order", {});
});

/**
 * Purchase event
 */
jQuery(document).on("pmw:purchase", async (event) => {

	pmw.console.log("pmw:purchase event fired", {event});

	// Use the unified event processor
	await pmw.processEvent("purchase", {
		order: pmwDataLayer.order,
	});
});

/**
 * Login event
 *
 * Uses the unified event processing system with filters.
 * Each pixel's adapter handles the data transformation.
 */
jQuery(document).on("pmw:login", async () => {

	pmw.console.log("pmw:login event fired");

	// Use the unified event processor
	await pmw.processEvent("login", {});
});

/**
 * Account created event
 *
 * Uses the unified event processing system with filters.
 * Each pixel's adapter handles the data transformation.
 */
jQuery(document).on("pmw:account-created", async () => {

	pmw.console.log("pmw:account-created event fired");

	// Use the unified event processor
	await pmw.processEvent("account_created", {});
});

/**
 * Run WooCommerce specific functions
 */
jQuery(document).on("pmw:ready", async () => {

	// Only run if WooCommerce is active
	if (!pmw.isWooCommerceActive()) {
		return;
	}

	/**
	 * Run as soon as wpm namespace is loaded
	 */

	// Watch for products visible in viewport
	pmw.startIntersectionObserverToWatch();

	// Watch for lazy loaded products
	pmw.startProductsMutationObserverToWatch();
});

jQuery(document).on("pmw:load-pixels", () => {
	pmw.waitForPixelsAndTriggerPageView();
});
